import { toRems } from "../../helpers/theme";

const style = ({ theme, disableTopSpacing, disableBottomSpacing }) => ({
    display: "flex",
    flexDirection: "column",
    zIndex: theme.zIndex.over,
    width: "100%",
    height: "100%",
    "& .drawerBody_inner": {
        width: "100%",
        height: "100%",
        display: "grid",
        padding: toRems([15, theme.global.drawer.hSpacing.mobile, 15]),
        [theme.breakpoints.up("md")]: {
            padding: toRems([30, theme.global.drawer.hSpacing.desktop, 30]),
        },
        ...(disableTopSpacing && {
            paddingTop: 0,
        }),
        ...(disableBottomSpacing && {
            paddingBottom: 0,
        }),
    },
});

export default style;
